import { css, styled } from '@styles/theme'

export const SettingsStyles = {
	container: css({
		background: '$neutral30',
		padding: '24px',
		width: '100%',
		maxWidth: '1369px',

		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),
	containerContent: css({
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		gap: 32,
		marginTop: 30,

		'@md': {
			flexDirection: 'row',
		},
	}),
	containerInfos: css({
		width: '100%',
		maxWidth: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		gap: 32,

		'@md': {
			maxWidth: 418,
		},
	}),
	containerPlus: css({
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		maxWidth: '100%',
		gap: 32,

		'@md': {
			maxWidth: 718,
		},
	}),
	title: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginTop: '40px',
	}),
	buttonIcon: css({
		cursor: 'pointer',
		color: '$neutral130',

		'&:hover': {
			color: '$primary',
		},
	}),
	buttonUnderline: css({
		fontSize: '$lg',
		fontWeight: 400,
		color: '$neutral90',
		textDecoration: 'underline',
		cursor: 'pointer',
	}),
	icon: css({
		color: '$neutral130',
	}),
}

export const InfoMe = styled('div', {
	width: '100%',
	maxWidth: '100%',
	padding: '17px 32px',
	borderRadius: 12,
	backgroundColor: '$neutral10',
	border: '1px solid $neutral50',
	display: 'flex',
	alignItems: 'center',
	gap: 39,
	'& h4': {
		_font: 'normal',
		fontSize: '$xl',
		fontWeight: 500,
		lineHeight: '19px',
		color: '$neutral130',
	},
	'& hr': {
		width: '100%',
		margin: '10px 0 8px',
		borderColor: '$neutral50',
	},
	span: {
		width: '66px',
		height: '66px',
	},

	'@md': {
		maxWidth: 418,
	},
})

export const InfoPersonal = styled('div', {
	width: '100%',
	maxWidth: '100%',
	padding: '24px 32px',
	borderRadius: 12,
	backgroundColor: '$neutral10',
	border: '1px solid $neutral50',
	'& p': {
		fontSize: '$xl',
		fontFamily: 'Roboto',
		fontWeight: 500,
		color: '$neutral160',
	},

	'@md': {
		maxWidth: 418,
	},
})

export const InfoPersonalHeader = styled('div', {
	width: '100%',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	paddingBottom: 16,
	borderBottom: '1px solid #F2EDF3',
	'& h2': {
		fontSize: '$xl',
		fontFamily: 'Roboto',
		fontWeight: 500,
		color: '$neutral160',
	},
	'& div': {
		fontSize: '$lg',
		fontWeight: 400,
		color: '$neutral90',
		textDecoration: 'underline',
		cursor: 'pointer',
	},
})

export const InfoPersonalBody = styled('div', {
	width: '100%',
	paddingTop: 6,
	'& p': {
		fontSize: '$md',
		fontFamily: 'Roboto',
		fontWeight: 500,
		color: '$neutral160',
		paddingTop: 15,
	},
})

export const ChangePassword = styled('div', {
	width: '100%',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	paddingBottom: 16,
	backgroundColor: '$neutral10',
	padding: '24px 32px',
	border: '1px solid $neutral50',
	borderRadius: 12,

	svg: {
		color: '$neutral100',
	},
})

export const Class = styled('div', {
	width: '100%',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	paddingBottom: 16,
	backgroundColor: '$neutral10',
	border: '1px solid $neutral50',
	padding: '24px 32px',
	borderRadius: 12,
	'& h2': {
		fontSize: '$xl',
		fontFamily: 'Roboto',
		fontWeight: 500,
		color: '$neutral160',
	},
	'& div': {
		fontSize: '$lg',
		fontWeight: 400,
		color: '$neutral90',
		textDecoration: 'underline',
		cursor: 'pointer',
	},
})

export const ContainerLogs = styled('div', {
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	alignItems: 'center',
	paddingBottom: 16,
	backgroundColor: '$neutral10',
	border: '1px solid $neutral50',
	padding: '24px 26px',
	borderRadius: 12,

	'.contaier-log-desc': {
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
	},
})

export const ChangeTheme = styled('div', {
	width: '100%',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	paddingBottom: 16,
	backgroundColor: '$neutral10',
	border: '1px solid $neutral50',
	padding: '24px 32px',
	borderRadius: 12,
	'& h2': {
		fontSize: '$xl',
		fontFamily: 'Roboto',
		fontWeight: 500,
		color: '$neutral160',
	},
	'& input': {
		width: '50px',
		height: '50px',
		color: 'red',
		background: 'red',
	},

	svg: {
		color: '$neutral100',
	},
})

export const DeleteBox = styled('div', {
	width: '100%',
	display: 'flex',
	justifyContent: 'end',
	alignItems: 'center',
	padding: '24px 32px',
	marginTop: 25,
	'& span': {
		fontSize: '$lg',
		fontWeight: 400,
		color: '$red',
		textDecoration: 'underline',
		cursor: 'pointer',
	},
})
